module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfe_notifications_remoteEntry_mjs_543bc05b__;